import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useAuth } from "@/hooks/useAuth";
import { allDemoEmails } from "./constants";

/** True when the signed-in user is any of the shared dev demo accounts. */
export function useIsDemoUser(): boolean {
  const { user } = useCurrentUser();
  const { firebaseUser } = useAuth();
  if (user?.isDemo === true) return true;
  const email = firebaseUser?.email?.toLowerCase();
  if (!email) return false;
  return allDemoEmails().includes(email);
}
